module.exports = __webpack_public_path__ + "img/1.607bb564.png";